import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from 'react';
import AuthGuard from '../components/AuthGuard';
import Login from '../components/Login';
import HomeLayout from "../Layouts/HomeLayout";
import ErrorPage from "../Pages/ErrorPage";
import Home01 from "../Pages/HomePages/Home01"; // Import directly instead of lazy loading

// Lazy-loaded components
const Dashboard = lazy(() => import('../components/Dashboard'));
const AboutUs = lazy(() => import('../Pages/AboutUs'));
const Leadership = lazy(() => import('../Pages/TeamPages/Leadership'));
const LeaderDetails = lazy(() => import('../Pages/TeamPages/LeaderDetails'));
const Contact = lazy(() => import('../Pages/Contact'));
const ProjectDetails = lazy(() => import('../Pages/ProjectPages/ProjectDetails'));
const ProjectGallery = lazy(() => import('../containers/ProjectContainers/ProjectGallery'));
const TermsAndConditions = lazy(() => import('../Pages/Terms'));

// Loading component
const LoadingFallback = () => <div className="loading-container">Loading...</div>;

export const routes = createBrowserRouter([
    {
        path: "/",
        element: <HomeLayout />,
        children: [
            {
                path: '/projects',
                element: <Suspense fallback={<LoadingFallback />}><ProjectGallery /></Suspense>,
            },
            {
                path: '/project-details',
                element: <Suspense fallback={<LoadingFallback />}><ProjectDetails /></Suspense>,
            },
            {
               path: '/leadership',
               element: <Suspense fallback={<LoadingFallback />}><Leadership /></Suspense>,
            },
            {
                path: '/leader-details',
                element: <Suspense fallback={<LoadingFallback />}><LeaderDetails /></Suspense>,
            },
            {
                path: '/contact',
                element: <Suspense fallback={<LoadingFallback />}><Contact /></Suspense>,
            },
            {
                path: '/about',
                element: <Suspense fallback={<LoadingFallback />}><AboutUs /></Suspense>,
            },
            {
                path: '/login',
                element: <Login />, // Not lazy-loaded for faster authentication access
            },
            // Add protected dashboard route
            {
                path: '/dashboard',
                element: (
                    <AuthGuard>
                        <Suspense fallback={<LoadingFallback />}>
                            <Dashboard />
                        </Suspense>
                    </AuthGuard>
                ),
            },
            {
                path: '/terms',
                element: <Suspense fallback={<LoadingFallback />}><TermsAndConditions /></Suspense>,
            },
            {
                path: '*',
                element: <ErrorPage />,
            },
        ]
    }
]);
